<template>
  <div>
    <div class="fixbar w-100 d-block" :class="{'close__fixbar' : closeTab}">
      <div class="container h-100">
        <div class="row h-100 align-items-center">
          <div class="col-4 col-lg-3 d-flex">
            <div class="col-2 icon">
              <img src="../assets/img/display.png" alt="Display">
            </div>
            <div class="col-md-10 p-0 d-none d-sm-flex">
              <a :href="'tel:'+phones.phone">
                <div class="fixbar__title">
                  LIGUE AGORA
                </div>
                <div class="fixbar__phone" v-if="phones.phone && phones.phone_formated">
                    {{phones.phone_formated}}
                </div>
              </a>
            </div>
            <div class="col-12 p-0 d-flex d-sm-none mobile">
              <a :href="'tel:'+phones.phone" class="d-flex mobile">
                <span>LIGUE</span>
                <img src="../assets/img/display.png" alt="Display" height="20px" width="20px">
              </a>
            </div>
          </div>
          <div class="col-4 col-lg-3 d-flex border-left">
            <div class="col-2 icon">
              <img src="../assets/img/whatsapp.png" alt="Display">
            </div>
            <div class="col-md-10 p-0 d-none d-sm-flex">
              <a :href="'https://api.whatsapp.com/send?phone=55'+phones.cellphone" target="_blank">
                <div class="fixbar__title">
                  ATENDIMENTO POR
                </div>
                <div class="fixbar__phone" v-if="phones.cellphone && phones.cellphone_formated">
                  WHATSAPP
                </div>
              </a>
            </div>
            <div class="col-12 p-0 d-flex d-sm-none mobile">
              <a :href="'https://api.whatsapp.com/send?phone=55'+phones.cellphone" target="_blank" class="d-flex mobile">
                <span>WHATSAPP</span>
                <img src="../assets/img/whatsapp.png" alt="Display" height="20px" width="20px">
              </a>
            </div>
          </div>
          <div class="col-4 col-lg-3 d-flex border-left">
            <div class="col-2 icon">
              <img src="../assets/img/email.png" alt="Display">
            </div>
            <div class="col-md-10 p-0 d-none d-sm-flex">
              <router-link to="/contato">
                <div class="fixbar__title">
                  ATENDIMENTO POR
                </div>
                <div class="fixbar__phone">
                    E-MAIL
                </div>
              </router-link>
            </div>
            <div class="col-12 d-flex d-sm-none p-0 mobile">
              <router-link to="/contato" class="d-flex mobile">
                <span>E-MAIL</span>
                <img src="../assets/img/email.png" alt="Display" height="20px" width="20px">
              </router-link>
            </div>
          </div>
          <div class="col-lg-3 d-lg-flex d-none border-left">
            <div class="col-2 flex-column icon">
              {{years()}}
              <span>ANOS</span>
            </div>
            <div class="col-md-10 p-0">
              <router-link to="/sobre">
                <div class="fixbar__title">
                  GRUPO
                </div>
                <div class="fixbar__phone" v-if="phones.cellphone && phones.cellphone_formated">
                  COMCASA
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <button class="fixbar__close" @click="closeBar()">
        <img src="../assets/img/icon_close.png" title="Fechar">
      </button>
    </div>
    <div class="fixbar_right" :class="{'hidden__bar' : !closeTab}" @click="openBar()">
      <div class="row h-100 align-items-center">
        <div class="col">
          <div class="title">
            <div class="abrir">
              <img src="../assets/img/icon_open.png" title="Abrir">
            </div>
            Entre em <br>contato
          </div>
        </div>
      </div>
    </div>
     <!--
      modal Envie-nos um e-mail inicio
      Deixei comentado a parte do formulário pré-integrado
    -->
    <div class="modal fade" id="ModalEnvieEmail" tabindex="-1" role="dialog" aria-labelledby="ModalEnvieEmailLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Envie-nos um <b>e-mail</b>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitFormEmail" class="w-100 text-right">
              <input type="text" v-model="form.name" class="ui-input ui-input--green" placeholder="Nome" required>
              <input type="email" v-model="form.email" class="ui-input ui-input--green" placeholder="E-mail" required>
              <textarea class="ui-input ui-input--green" v-model="form.description" rows="7" placeholder="Mensagem" required></textarea>
              <button class="ui-button" type="submit" :disabled="disabled">
                {{submitButton}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- modal Envie-nos um e-mail fim -->

      <!--
      modal Ligamos para você inicio
      Deixei comentado a parte do formulário pré-integrado
      a máscara de telefone já está funcionando
    -->
    <div class="modal fade" id="ModalLigamosVoce" tabindex="-1" role="dialog" aria-labelledby="ModalLigamosVoceLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Ligamos para <b>você</b>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitFormContact" class="w-100 text-right">
              <input type="text" v-model="contact.name" class="ui-input ui-input--green" placeholder="Nome" required>
              <input type="email" v-model="contact.email" class="ui-input ui-input--green" placeholder="E-mail" required>
              <the-mask class="ui-input ui-input--green" v-model="contact.phone" :mask="['(##) ####-####', '(##) #####-####']" placeholder="Telefone" required />
              <button class="ui-button" type="submit" :disabled="disabled">
                {{submitButton}}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- modal Ligamos para você fim -->
  </div>
</template>
<script>
import swal from 'sweetalert2'
import {TheMask} from 'vue-the-mask'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      phones: {},
      disabled: false,
      submitButton: 'Enviar',
      closeTab: false,
      form: {
        name: '',
        email: '',
        description: ''
      },
      contact: {
        name: '',
        email: '',
        phone: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'companyData',
      'contactSend'
    ])
  },
  components: {
    TheMask
  },
  created () {
    this.$store.dispatch('listCompanyData')
      .then(() => {
        this.phones = this.companyData
        if (this.phones.cellphone) {
          let cellphoneP1 = this.phones.cellphone.slice(0, 2)
          let cellphoneP2 = this.phones.cellphone.slice(2, 6)
          if (this.phones.cellphone.length === 11) {
            cellphoneP2 = this.phones.cellphone.slice(2, 7)
          }
          let cellphoneP3 = this.phones.cellphone.slice(-4)

          this.phones.cellphone_formated = cellphoneP1 + '. ' + cellphoneP2 + '.' + cellphoneP3
        }

        if (this.phones.phone) {
          let phoneP1 = this.phones.phone.slice(0, 2)
          let phoneP2 = this.phones.phone.slice(2, 6)
          if (this.phones.phone.length === 11) {
            phoneP2 = this.phones.phone.slice(2, 7)
          }
          let phoneP3 = this.phones.phone.slice(-4)

          this.phones.phone_formated = phoneP1 + '. ' + phoneP2 + '.' + phoneP3
        }
      })
  },
  watch: {
  },
  methods: {
    years () {
      var comcasa = new Date('1981/01/14')
      var date = new Date()
      return Math.floor(Math.ceil(Math.abs(comcasa.getTime() - date.getTime()) / (1000 * 3600 * 24)) / 365.25)
    },
    submitFormEmail () {
      this.disabled = true
      this.submitButton = 'Enviando'
      let content = {
        'destiny': 'faleconosco.comcasa@gmail.com',
        'originName': 'Website Comcasa',
        'title': ' [COMCASA] Fale Conosco | Mensagens em Geral',
        'message': `Uma pessoa entrou em contato: <br><br>Nome: ${this.form.name}<br>E-mail: ${this.form.email}<br>Mensagem: ${this.form.description}`
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.form})
          swal(
            'Enviado :)',
            'E-mail enviado com sucesso.',
            'success'
          )
          this.form = {
            name: '',
            email: '',
            description: ''
          }
          this.disabled = false
          this.submitButton = 'Enviar'
        })
    },
    submitFormContact () {
      this.disabled = true
      this.submitButton = 'Enviando'
      let content = {
        'destiny': 'faleconosco.comcasa@gmail.com',
        'originName': 'Website Comcasa',
        'title': '[COMCASA] Ligamos para Você',
        'message': `Uma pessoa quer que entrem em contato com: <br><br>Nome: ${this.contact.name}<br>E-mail: ${this.contact.email}<br>Telefone: ${this.contact.phone}`
      }
      this.$store.dispatch('sendContactForm', {data: content})
        .then(() => {
          this.$store.dispatch('sendActiveCampaign', {data: this.contact})
          swal(
            `Muito obrigado, ${this.contact.name}`,
            'Em breve entraremos em contato! :)',
            'success'
          )
          this.contact = {
            name: '',
            email: '',
            phone: ''
          }
          this.disabled = false
          this.submitButton = 'Enviar'
        })
    },
    closeBar () {
      this.closeTab = true
      this.$emit('closed', true)
    },
    openBar () {
      this.closeTab = false
      this.$emit('closed', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.fixbar {
  background: #121522;
  opacity: 0.97;
  bottom: 0;
  height: 60px;
  position: fixed;
  transition: all 0.3s;
  z-index: 150;
  color: #FFF;
  a{
    color: #FFF;
    &:hover {
      color: $green;
      transition: all 0.3s;
    }
  }
  &__title {
    font-size: 14px;
  }
  &__phone {
    font-size: 20px;
    font-weight: 700;
  }
  &__close{
    border: none;
    background: transparent;
    position: absolute;
    top: -11px;
    right: 2px;
    font-weight: 300;
    outline: none;
    margin: 0px !important;
    width: 22px;
    padding: 0px;
    cursor: pointer;
  }
  button {
    margin: 0 10px;
  }
  .border-left {
    border-left: 1px solid #555 !important;
    border-left-width: thin;
  }
  .icon{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
    font-size: 30px;
    font-weight: 600;
    margin-right: 15px;
    img{
      height: 25px;
    }
    span{
      margin-top: 0px;
      margin-bottom: -3px;
      font-size: 14px;
      font-weight: 100;
    }
    @media (max-width: 767px) {
      display: none
    }
  }
  .mobile{
    flex-direction: column;
    align-items: center;
    font-size: 12px;
  }
  @media (max-width: 1200px) {
    .icon{
      font-size: 28px;
      img{
        height: 20px;
      }
    }
    button {
      min-width: inherit;
      padding-left: 30px;
      padding-right: 30px;
    }
    &__phone {
      font-size: 16px;
    }
  }
  @media (max-width: 991px) {
    &__title {
      font-size: 13px;
    }
    &__phone {
      font-size: 16px;
    }
  }
}
.close__fixbar {
  bottom: -91px;
  transition: all 0.3s;
}
.fixbar_right {
  background: #121522;
  opacity: 0.97;
  color:#FFF;
  box-shadow: -3px -3px 10px 0px rgba(114, 114, 119, 0.2);
  border-radius: 10px 0px 0px 10px;
  bottom: 0;
  cursor: pointer;
  height: 70px;
  padding-left: 5px;
  padding-right: 55px;
  position: fixed;
  right: 0;
  transition: all 0.3s;
  width: 140px;
  z-index: 150;
  .title {
    font-size: 16px;
    font-weight: 300;
    text-align: left;
    outline: none;
    line-height: 18px;
    transition: all 0.1s;
    &:hover {
      transition: all 0.1s;
      font-weight: 400;
    }
  }
  .abrir {
    background: transparent;
    display: none;
    border: none;
    cursor: pointer;
    left: 2px;
    margin: 0px !important;
    padding: 0px;
    position: absolute;
    top: -25px;
    width: 22px;
  }
}
.hidden__bar {
  bottom: -80px;
  transition: all 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeFixBar.vue